<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show">
                        <v-toolbar dark color="blue">
                            <v-toolbar-title class="my-0 py-0">Objetivo</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-toolbar>
                    </v-card>
                    <v-card color="blue lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="2">
                                    Año: {{ periodo }}
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    Objetivo: {{ clave }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    N° de Objetivo: {{ codgral }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    Objetivo Asociado: {{ asociado }}
                                </v-col>
                                <v-col cols="6" sm="6" md="3">
                                    Tipo: {{ tipo }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="2">
                                    Proceso: {{ proceso }}
                                </v-col>
                                <v-col cols="6" sm="8" md="2">
                                    Subproceso: {{ subproceso }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    Descripción de Objetivo: {{ objetivo }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    Meta: {{ meta }}
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="3">
                                    Responsable: {{ responsable }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    Plazo: {{ plazo }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    Indicador: {{ indicador }}
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    Plan: {{ plan }}
                                </v-col>
                                <v-col cols="6" sm="8" md="3">
                                    Área: {{ area }}
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card>
                        <v-card-text>
                            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" :items-per-page="200"
                                hide-default-footer class="pa-0 ma-0">
                                <!-- <template v-slot:item.valoractual="{ item }">
                                    <v-text-field dense v-model="item.valoractual"
                                        class="font-class-name"></v-text-field>
                                </template>
<template v-slot:item.refparcial="{ item }">
                                    <v-text-field dense v-model="item.refparcial"
                                        class="font-class-name"></v-text-field>
                                </template>
<template v-slot:item.observ="{ item }">
                                    <v-text-field dense v-model="item.observ" class="font-class-name"></v-text-field>
                                </template> -->
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                    <v-card color="blue lighten-4">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="10">
                                    Observaciones / Evidencias: {{ observ }}
                                </v-col>
                                <!-- <v-col cols="12" sm="12" md="2">
                                    <v-text-field dense v-model="fecha" label="Fecha de Revisión"
                                        outlined></v-text-field>
                                </v-col> -->
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <!-- <v-card color="blue" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>  -->
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>

<script>
import { subtract } from "lodash";
import axios from "../../axios-auth";
import moment from "moment";
export default {
    data: (vm) => ({
        lazy: false,
        valid: false,
        //codgral: "",
        periodo: "",
        clave: "",
        asociado: "",
        proceso: "",
        subproceso: "",
        objetivo: "",
        tipo: "",
        meta: "",
        responsable: "",
        plazo: "",
        indicador: "",
        valorant: "",
        plan: "",
        area: "",
        filtroarea: "",
        filtrosubproceso: "",
        observ: "",
        deshabilitar: false,
        clavearea: [{ value: "C", text: "Clave" },
        { value: "A", text: "De Área" },
        ],
        objasociado: [{ value: "201", text: "201" },
        { value: "202", text: "202" },
        { value: "203", text: "203" },
        { value: "204", text: "204" },
        { value: "205", text: "205" },
        ],
        tipos: [{ value: "E", text: "Estratégico" },
        { value: "O", text: "Operativo" },
        ],
        areas: [
            { value: "Administración", text: "Administración" },
            { value: "Abastecimiento", text: "Abastecimiento" },
            { value: "Depósito", text: "Depósito" },
            { value: "Personal y RRHH", text: "Personal y RRHH" },
            { value: "Control de Gestión", text: "Control de Gestión" },
            { value: "Sistemas", text: "Sistemas" },
            { value: "Comercial", text: "Comercial" },
            { value: "Ventas", text: "Ventas" },
            { value: "Marketing", text: "Marketing" },
            { value: "Secretaría Comercial", text: "Secretaría Comercial" },
            { value: "Ingeniería de Obra", text: "Ingeniería de Obra" },
            { value: "Obras y Servicios", text: "Obras y Servicios" },
            { value: "Ingeniería de Producto", text: "Ingeniería de Producto" },
            { value: "Fabricación", text: "Fabricación" },
            { value: "Sucursal Bs As", text: "Sucursal Bs As" },
            { value: "Técnica y Desarrollo", text: "Técnica y Desarrollo" },
            { value: "SSGG y Mantenimiento", text: "SSGG y Mantenimiento" },
            { value: "Gerencia del SGI", text: "Gerencia del SGI" },
            { value: "Inspección y Ensayo", text: "Inspección y Ensayo" },
            { value: "Higiene y Seguridad", text: "Higiene y Seguridad" },
            { value: "Medio Ambiente", text: "Medio Ambiente" },
            { value: "Medicina Laboral", text: "Medicina Laboral" },
            { value: "Brigadas", text: "Brigadas" }
        ],

        listado: [],
        tiposref: [{ value: "CU", text: "Cumplimiento" },
        { value: "N", text: "Numérico" },
        { value: "P", text: "Porcentual" },
        { value: "I", text: "Indicador" },
        { value: "CA", text: "Capacitación" },
        { value: "DA", text: "Dato" },
        { value: "PL", text: "Plan" },
        ],
        condiciones: [{ value: "MA", text: "Mayor a la referencia" },
        { value: "ME", text: "Menor a la referencia" },
        { value: "IG", text: "Igual a la referencia" },
        ],
        headers: [{
            text: "Descripción de la Referencia",
            align: "start",
            sortable: false,
            value: "descr",
            width: "40%"
        },
        { text: "Tipo de Referencia", value: "nombretipo", sortable: false },
        { text: "Condición de Cumplimiento", value: "nombrecondicion", sortable: false },
        { text: "Valor de Referencia", value: "referencia", sortable: false },
        { text: "Valor Actual", value: "valoractual", sortable: false },
        { text: "Referencia Parcial", value: "refparcial", sortable: false },
        { text: "Observaciones", value: "observ", sortable: false },
        ],
        listadoref: [],
    }),
    props: ["visible", "codgral", "fecha"],
    computed: {
        show: {
            get() {
                if (this.visible == true) {
                    this.cargardatos();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        cargardatos() {
            const codgral = this.codgral;
            const fecha = this.fecha;
            let self = this;
            axios
                .get("/Indicadores/CargarObjetivoParcial?", {
                    params: {
                        codgral: codgral,
                        fecha: fecha,
                    },
                })
                .then((response) => {
                    self.objetivo = response.data.objetivo;
                    self.proceso = response.data.proceso;
                    self.subproceso = response.data.subproceso;
                    self.meta = response.data.meta;
                    self.indicador = response.data.indicador;
                    self.plan = response.data.plan;
                    self.area = response.data.area;
                    self.asociado = response.data.asociado;
                    self.tipo = response.data.tipo;
                    self.clave = response.data.clave;
                    self.responsable = response.data.responsable;
                    self.plazo = response.data.plazo;
                    self.valorant = response.data.valorant;
                    self.observ = response.data.observ;
                    self.periodo = response.data.periodo;
                    self.listado = response.data.referencias;
                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        vaciarModels() {
            this.periodo = "";
            this.objetivo = "";
            this.proceso = "";
            this.subproceso = "";
            this.meta = "";
            this.indicador = "";
            this.plan = "";
            this.area = "";
            this.asociado = "";
            this.tipo = "";
            this.clave = "";
            this.responsable = "";
            this.plazo = "";
            this.valorant = "";
            this.deshabilitar = false;

        },
    },
}
</script>